import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PermissionTypesEnum } from '@api/ringil-api.v2';
import { TimeslotCalendar } from '@app/pages/timeslots/calendar/TimeslotCalendar.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {}

const CalendarPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  return (
    <>
      <ResponsiveLayout
        layout="calendar"
        title={tr(`calendar.calendar`, `Calendar`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_TIMESLOT_DASHBOARD_READ, PermissionTypesEnum.PERMISSION_TIMESLOT_DASHBOARD_RW]}
      >
        <TimeslotCalendar />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CalendarPage);
